//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonClassifier from '@/components/nav_common/CommonClassifier'
import { Author, Collection } from '@/models'

export default {
  data () {
    return {
      contents: [
        /* {
          title: '朝代',
          classList: [
            "先秦",
            "两汉",
            "魏晋",
            "南北朝",
            "隋代",
            "唐代",
            "五代",
            "宋代",
            "金朝",
            "元代",
            "明代",
            "清代",
          ]
        },
        {
          title: '体裁',
          classList: [
            "诗",
            "词",
            "曲",
            "文言文",
          ]
        } */
      ]
    }
  },
  components: {
    CommonClassifier
  },
  beforeCreate () {
    Author.getHotAuthorsByLikers(1, 30).then(result => {
      let content = { title: '作者', routePrev: '/author/'}

      content.classList = result.map(item => {
        return {
          id: item.id,
          text: item.get('name')
        }
      })

      this.contents.unshift(content)
    })

    Collection.getCollections().then(result => {
      let content = { title: '分类', routePrev: '/collection/'}
      // console.log(result)

      content.classList = result.map(item => {
        return {
          id: item.id,
          text: item.get('name')
        }
      })

      this.contents.unshift(content)
    })
  },
  methods: {
    goToAuthor (item) {
      this.$router.push({
        name: 'author',
        params: {
          id: item.id
        }
      })
    },

    goToCollection (item) {
      this.$router.push({
        name: 'collection',
        params: {
          id: item.id
        }
      })
    },

    chooseNavgate (item, title) {
      switch(title) {
        case '作者': 
          this.goToAuthor(item)
          break
        case '分类': 
          this.goToCollection(item)
          break
        // case '体裁': 
        //   this.break
        // case '朝代': break
      } 
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/nav_cipai/CipaiRight.vue